var Rules = React.createClass({
	mixins: [React.addons.PureRenderMixin],

	render: function() {
		return (
			<div>
				<h1>Rules</h1>
				<hr />
				Rules will be updated based on circumstances, and any breach of rules will result in permanent bans.
				<hr />
				<ol>
					<li>Racism, sexism, or any form of degradation will not be tolerated.</li>
					<li>Do not post “offensive” posts, links or images.</li>
				</ol>
				<SeeAlso />
			</div>
		)
	},
})
